export const DEMAND_STATUS = {
  0: '待审',
  1: '招募',
  2: '撮合中',
  3: '成功',
  4: '失败',
  5: '关闭'
}

export const MATCH_STATUS = {
  0: '撮合中',
  1: '已撮合',
  2: '已拒绝'
}

export const AUDIT_STATUS = {
  0: '待审',
  1: '通过',
  2: '驳回'
}

export const PAY_STATUS = {
  0: '待付',
  1: '已付'
}

export const EXEC_STATUS = {
  0: '待处理',
  1: '已完成'
}

export const COPYRIGHT_STATUS = {
  0: '待审核',
  1: '已通过',
  2: '已驳回',
  3: '待支付'
}

export const COPYRIGHT_AUDIT_STATUS = {
  0: '待处理',
  1: '已通过',
  2: '已驳回',
  3: '已通过'
}

export const COPYRIGHT_PAY_STATUS = {
  0: '未支付',
  1: '已支付',
  2: '未支付',
  3: '未支付'
}

export const WORK_MEDIA_TYPE = {
  1: '视频作品',
  2: '图片作品',
  3: '图生视频'
}

/** 门户发布作品时的细分类型（work_type 新编码 10+） */
export const WORK_PUBLISH_TYPE = {
  10: '短视频',
  11: '长视频',
  12: '摄影作品',
  13: '平面设计',
  14: '动画',
  15: '文案',
  16: '其他',
  // 历史数据：1 视频 2 图片 3 图生视频
  1: '视频作品',
  2: '图片作品',
  3: '图生视频'
}

export const WORK_CREATION_TYPE = {
  1: '文生视频',
  2: '文生图',
  3: '图生视频'
}

export function workTypeDisplay(value) {
  if (value == null || value === '') return '-'
  if (WORK_PUBLISH_TYPE[value] != null) return WORK_PUBLISH_TYPE[value]
  if (WORK_MEDIA_TYPE[value] != null) return WORK_MEDIA_TYPE[value]
  return String(value)
}

export const INVOICE_STATUS = {
  0: '申请中',
  1: '已开票'
}

export const SYSTEM_NOTICE_STATUS = {
  0: '草稿',
  1: '已推送'
}

export const FEEDBACK_STATUS = {
  0: '待处理',
  1: '处理中',
  2: '已解决'
}

export const AGENT_STATUS = {
  0: '待审',
  1: '通过',
  2: '驳回',
  3: '禁用'
}

export const WITHDRAWAL_STATUS = {
  0: '待审',
  1: '通过',
  2: '驳回'
}

export const COMMENT_STATUS = {
  0: '封禁',
  1: '正常'
}

export const CMS_ARTICLE_STATUS = {
  0: '草稿',
  1: '发布'
}

export const CMS_TYPE = {
  1: '新闻',
  2: '教程',
  3: '轮播',
  4: '培训'
}

export const COMMON_STATUS = {
  0: '禁用',
  1: '启用'
}

export const MENU_TYPE = {
  1: '目录',
  2: '菜单',
  3: '按钮'
}

export const MEMBER_TYPE = {
  1: '个人',
  2: '企业'
}

export const MEMBERSHIP_TIER = {
  basic: '基础版',
  plus: '进阶版',
  pro: '专业版',
  flagship: '旗舰版',
  supreme: '至尊版'
}

export function membershipTierLabel(tier) {
  if (tier == null || tier === '' || String(tier).toLowerCase() === 'none') {
    return '-'
  }
  const key = String(tier).toLowerCase()
  return MEMBERSHIP_TIER[key] != null ? MEMBERSHIP_TIER[key] : String(tier)
}

export const MEMBERSHIP_CYCLE = {
  monthly: '月费',
  yearly: '年费'
}

export function membershipCycleOptions() {
  return Object.keys(MEMBERSHIP_CYCLE).map(key => ({
    value: key,
    label: MEMBERSHIP_CYCLE[key]
  }))
}

export function membershipCycleLabel(cycle) {
  const key = String(cycle || '').toLowerCase()
  if (key === 'yearly') return '年费'
  if (key === 'monthly') return '月费'
  return ''
}

export function membershipLevelLabel(tier, cycle) {
  const tierLabel = membershipTierLabel(tier)
  if (tierLabel === '-') return '-'
  const cycleLabel = membershipCycleLabel(cycle)
  return cycleLabel ? `${tierLabel}·${cycleLabel}` : tierLabel
}

export const PORTAL_USER_STATUS = {
  0: '已封停',
  1: '正常',
  2: '待审核',
  3: '已删除'
}

export const ENTERPRISE_AUDIT_STATUS = {
  0: '未申请',
  1: '待审核',
  2: '已通过',
  3: '已驳回'
}

export function labelOf(map, value) {
  if (value == null || value === '') return '-'
  return map[value] != null ? map[value] : String(value)
}

export function optionsOf(map) {
  return Object.keys(map).map(key => ({
    value: Number(key),
    label: map[key]
  }))
}
